/* eslint-disable multiline-ternary */
import Header from 'src/components/header/Header';
import { Button, InfiniteScroll, Loader } from 'src/components/common';

import Banner from 'src/components/venture/banner/Banner';

import './venture.scss'
import { Col, Row } from 'react-bootstrap';
import VentureCard from 'src/components/venture/venturecard/VentureCard';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { clearMyVenture, clearVentureList, getGlobalOngoingDemoDay, getMyVenture, getVentureCounters, getVentureList, increamentVenturePage, resetVentureList } from 'src/store/venture/venture.slice';
import ListingModal from 'src/components/common/ListingModal/ListingModal';
import { FaAngleDown } from 'react-icons/fa6';
import { changeFilterModalState } from 'src/store/program/program.slice';
import { TSelectOptions } from 'src/components/common/formFields/selectField/SelectField';
import { SelectedIndustries } from 'src/constants/user.constants';
import { enumToJson } from 'src/utils';
import { useGetIdentity } from 'src/hooks';
import { Helmet } from 'react-helmet';
import { TSingleVentureRequest, TVenture, TVentureRequest } from 'src/services/apiEndpoint.types.ts/ventures/ventures.types';
import DemoDayBanner from 'src/components/venture/demoday-banner/DemoDayBanner';

export type TVenturefilterProps = { domain: string[], ventureStage: string[], hiring: string[], fundingStage: string[], sortBy?: string }
const Venture = () => {
  const dispatch = useAppDispatch();
  const { getIdentities } = useGetIdentity();
  const { ventures, venturesPageNumber, venturesPerPage, moreVenturesLeft, globalDemoDay } = useAppSelector(
    (store) => store.venture
  );
  const { filterModal } = useAppSelector(
    (store) => store.program
  );
  const { loading } = useAppSelector(
    (store) => store.common
  );
  const { authenticatedId, loggedInUserType } = getIdentities();

  // state
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [sortBy, setSortBy] = useState('Recently Added')
  const [filter, setFilter] = useState<TVenturefilterProps>({ domain: [], ventureStage: [], hiring: [], fundingStage: [], sortBy: 'Recently Added' });
  const isDemoDayRunning = !!globalDemoDay?.[0]?.id;
  const ventureStageOptions: TSelectOptions[] = [
    {
      label: 'Idea',
      value: 'Idea',
      id: 'Idea'
    },
    {
      label: 'Prototype',
      value: 'Prototype',
      id: 'Prototype'
    },
    {
      label: 'Early Traction',
      value: 'Early Traction',
      id: 'Early Traction'
    },
    {
      label: 'Scaling',
      value: 'Scaling',
      id: 'Scaling'
    }
  ]
  const fundingStageOptions: TSelectOptions[] = [
    {
      label: 'Bootstrap',
      value: 'Bootstrap',
      id: 'Bootstrap'
    },
    {
      label: 'Pre Seed',
      value: 'Pre Seed',
      id: 'Pre Seed'
    },
    {
      label: 'Seed',
      value: 'Seed',
      id: 'Seed'
    },
    {
      label: 'Series A & onwards',
      value: 'Series A Onwards',
      id: 'Series A Onwards'
    }
  ]
  const hiringOptions: TSelectOptions[] = [
    {
      label: 'Co-Founder',
      value: 'Co-Founder',
      id: 'Co-Founder'
    }
  ]
  const soryByOptions: TSelectOptions[] = [
    {
      label: 'Recently Added',
      value: 'Recently Added',
      id: 'Recently Added'
    },
    {
      label: 'Trending Ventures',
      value: 'Feeling Lucky',
      id: 'Feeling Lucky'
    },
    {
      label: 'Most Voted',
      value: 'Most Voted',
      id: 'Most Voted'
    }
  ]

  if (authenticatedId) {
    soryByOptions.push({
      label: 'My Venture',
      value: 'My Venture',
      id: 'My Venture'
    })
  }
  const industriesOptions: TSelectOptions[] = enumToJson({
    enumData: SelectedIndustries
  })

  const fetchListVenture = ({ reload = false }: { reload?: boolean }) => {
    if (reload) {
      dispatch(resetVentureList());
    }
    const payload: TVentureRequest = {
      limit: venturesPerPage || 50,
      page: venturesPageNumber,
      ...(!authenticatedId ? {} : loggedInUserType === 'Company' ? { companyId: authenticatedId } : { userId: authenticatedId }),
      ...(filter.domain?.length > 0 && filter.domain.length !== industriesOptions.length ? { domain: filter.domain?.join(',') } : {}),
      ...(filter.ventureStage?.length > 0 && filter.ventureStage.length !== ventureStageOptions.length ? { ventureStage: filter.ventureStage?.join(',') } : {}),
      ...(filter.fundingStage?.length > 0 && filter.fundingStage.length !== fundingStageOptions.length ? { fundingStage: filter.fundingStage?.map((item) => item === 'Series A & onwards' ? 'Series A Onwards' : item)?.join(',') } : {}),
      ...(filter.hiring?.length > 0 ? { hiring: filter.hiring?.join(',') } : {}),
      ...(sortBy !== 'Recently Added' ? { sortBy } : {}),
      ...(sortBy === 'My Venture' ? { sortBy } : {})
    }
    dispatch(getVentureList(payload))
  };

  const loadMoreItems = () => {
    if (moreVenturesLeft && !loading) {
      dispatch(increamentVenturePage(1));
    }
  };
  function handleListModal(type: string) {
    const data = type === filterModal.state ? [] : type === 'sortBy' ? soryByOptions : type === 'domain' ? industriesOptions : type === 'ventureStage' ? ventureStageOptions : type === 'hiring' ? hiringOptions : fundingStageOptions
    dispatch(changeFilterModalState({ state: type === filterModal.state ? '' : type, data }))
  }
  function handleAction(type: string, filterType: string) {
    const value = type === 'clear-all' ? [] : filterType === 'domain' ? industriesOptions.map((item) => item.label) : filterType === 'ventureStage' ? ventureStageOptions.map((item) => item.label) : filterType === 'hiring' ? hiringOptions.map((item) => item.label) : filterType === 'sortBy' ? soryByOptions.map((item) => item.label) : fundingStageOptions.map((item) => item.label)
    setFilter({ ...filter, [filterType]: value })
  }

  function handleSelect(value: string, type: string, checked: boolean) {
    if (type) {
      const valuesArr = checked ? [...filter[type], value] : filter[type]?.filter((item: string) => item !== value);
      setFilter({ ...filter, [type]: valuesArr })
    }
  }

  useEffect(() => {
    if (!loading) {
      fetchListVenture({ reload: false });
    }
  }, [venturesPerPage, venturesPageNumber, filter, sortBy]);
  useEffect(() => {
    const ventureStage = ventureStageOptions?.map((item) => item.label);
    const fundingStage = fundingStageOptions?.map((item) => item.label);
    const domain = industriesOptions?.map((item) => item.label);
    setFilter({ ...filter, ventureStage, fundingStage, domain })
  }, [])

  useEffect(() => {
    const payload: TSingleVentureRequest = {
      ...(!authenticatedId ? {} : loggedInUserType === 'User' ? { userId: authenticatedId } : { companyId: authenticatedId })
    }
    dispatch(getVentureCounters(payload))
    dispatch(getGlobalOngoingDemoDay())
    return () => {
      dispatch(clearMyVenture())
      dispatch(clearVentureList())
    }
  }, [dispatch, loggedInUserType, authenticatedId])

  return (
    <>
      <Helmet>
        <title>htraction | Explore Ventures & Startup Journeys</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta
          name="description"
          content="Discover promising startups and venture journeys on htraction. Explore new ideas, business models, and innovative entrepreneurs shaping the future."
        />
        <meta property="og:title" content="htraction | Explore Ventures & Startup Journeys" />
        <meta
          property="og:description"
          content="Discover promising startups and venture journeys on htraction. Explore new ideas, business models, and innovative entrepreneurs shaping the future."
        />
        <meta property="og:image" content="https://castling.in/ogimage.png?v=2" />
        <meta property="og:url" content="https://castling.in/ventures" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="htraction | Explore Ventures & Startup Journeys" />
        <meta
          name="twitter:description"
          content="Discover promising startups and venture journeys on htraction. Explore new ideas, business models, and innovative entrepreneurs shaping the future."
        />
        <meta name="twitter:image" content="https://castling.in/ogimage.png?v=2" />
      </Helmet>
      <InfiniteScroll
        className="venture"
        onScrollEnd={loadMoreItems}
        loading={false}
        showLoader={false}
        showFooter={false}
        moreItemsLeft={false}
      >
        <Header />
        <div className="venture__body venture__newBody">
          <div className="venture__body__feed">
            {isDemoDayRunning ? <DemoDayBanner /> : <Banner />}
            <div className="dashboard__body__feed__actions">
              {<div className='dashboard__body__feed' style={{ width: '100%', opacity: isModalOpen ? '0' : '1' }}>
                <Row>
                  <Col md={8}>
                    <div className='dashboard__body__feed__actions__filters__venture'>
                      <p>Filters:</p>
                      <div className='dashboard__body__feed__actions__filters__filterBox'>
                        <div className='dashboard__body__feed__actions__filters__date-field'>
                          <Button variant={filter.domain.length > 0 ? "primary" : "secondary"} size="extraSmall" onClick={() => handleListModal('domain')}>Domain <FaAngleDown /></Button>
                          {filterModal.state && filterModal.state === 'domain' && <ListingModal filter={filter} handleAction={handleAction} handleSelect={handleSelect} />}
                        </div>
                        <div className='dashboard__body__feed__actions__filters__date-field'>
                          <Button variant={filter.ventureStage.length > 0 ? "primary" : "secondary"} size="extraSmall" onClick={() => handleListModal('ventureStage')}>Venture Stage <FaAngleDown /></Button>
                          {filterModal.state && filterModal.state === 'ventureStage' && <ListingModal filter={filter} handleAction={handleAction} handleSelect={handleSelect} />}
                        </div>
                        <div className='dashboard__body__feed__actions__filters__date-field'>
                          <Button variant={filter.hiring.length > 0 ? "primary" : "secondary"} size="extraSmall" onClick={() => handleListModal('hiring')}>Hiring <FaAngleDown /></Button>
                          {filterModal.state && filterModal.state === 'hiring' && <ListingModal filter={filter} handleAction={handleAction} handleSelect={handleSelect} />}
                        </div>
                        <div className='dashboard__body__feed__actions__filters__date-field'>
                          <Button variant={filter.fundingStage.length > 0 ? "primary" : "secondary"} size="extraSmall" onClick={() => handleListModal('fundingStage')}>Funding Stage <FaAngleDown /></Button>
                          {filterModal.state && filterModal.state === 'fundingStage' && <ListingModal filter={filter} handleAction={handleAction} handleSelect={handleSelect} />}
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={4} className='d-flex justify-content-right'>
                    <div className='dashboard__body__feed__actions__filters__auto'>
                      <p>Sort By:</p>
                      <div className='dashboard__body__feed__actions__filters__filterBox'>

                        <div className='dashboard__body__feed__actions__filters__date-field'>
                          <Button variant={"secondary"} size="extraSmall" onClick={() => handleListModal('sortBy')}>{sortBy === 'Feeling Lucky' ? 'Trending Ventures' : sortBy}<FaAngleDown /></Button>
                          {filterModal.state && filterModal.state === 'sortBy' && <ListingModal setSortBy={setSortBy} sortBy={sortBy} isListing={true} filter={filter} handleAction={handleAction} handleSelect={handleSelect} />}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              }
            </div>
            <Row className='g-3'>
              {ventures.map((venture: TVenture, i: number) => {
                return (
                  <Col md={4} key={i}>
                    <VentureCard venture={venture} />
                  </Col>
                )
              })}
            </Row>
            {loading && <Loader />}
            {!loading && moreVenturesLeft && (
              <Button
                className="infinite-scroll-component__footer"
                variant="tertiary"
                size="extraSmall"
                onClick={loadMoreItems}
              >
                {moreVenturesLeft ? 'Load more items' : <>&bull;</>}
              </Button>
            )}

          </div>

        </div>
      </InfiniteScroll>
    </>
  );
};

export default Venture;
